import http from '@/api/base'
// 获取任务列表
const selectMyTaskList = (params) => {
  return http.post('/ipark-admin/ipark-admin/processadmin/selectMyTaskList', params)
}
const getTaskNodeList = (params) => {
  return http.post('/ipark-admin/processadmin/getTaskNodeList', params)
}
const getTaskNodeList1 = (params) => {
  if (process.env.NODE_ENV === 'development') {
    // params.mockApi = true
  }
  return http.post('/portal/message/getTaskNodeList', params)
}
const selectAppovingDetailByPid = (params) => {
  return http.post('/ipark-admin/processadmin/selectAppovingDetailByPid', params)
}
// 流程转交
const transfer = (params) => {
  return http.post('/ipark-admin/processadmin/transfer', params)
}
// 流程审批
const submit = (params) => {
  return http.post('/ipark-admin/processadmin/submit', params)
}
// 流程附言
const addTaskComment = (params) => {
  return http.post('/ipark-admin/processadmin/addTaskComment', params)
}

const modifyRepairType = (params) => {
  return http.post('/repair/modifyRepairType', params)
}
const getRepairType = (params) => {
  return http.post('/repair/getRepairType', params)
}

// 月卡申请下一步
const appMcardApply = (params) => {
  return http.post('/mcard/appMcardApply', params)
}
// 月卡申请取消
const mcardApplyCancel = (params) => {
  return http.post('/mcard/mcardApplyCancel', params)
}

// 新增组织架构用户导入
const importUserResult = (params) => {
  return http.get('/umuser/importUserResult', {params, responseType: 'blob'})
}
// 员工认证
const enterpriseApplyList = (params) => {
  return http.post('/enterpriseUser/enterpriseApplyList', params)
}
// 业务信息
// 业务信息-统计服务数据统计
const serviceDataStatistics = (params) => {
  return http.post('/statistics/serviceDataStatistics', params)
}
// 业务信息-获取月卡统计数据
const enterpriseMcardStatistics = (params) => {
  return http.post('/statistics/enterpriseMcardStatistics', params)
}
// 业务信息-统计业务里的公司月卡列表
const enterpriseMcardPageList = (params) => {
  return http.post('/statistics/enterpriseMcardPageList', params)
}
// 门禁信息-企业新增访客授权数据
const getStatisticsAgentAuthData = (params) => {
  return http.post('/entrancecontrol/getStatisticsAgentAuthData', params)
}
// 门禁信息-企业通行记录数据统计 通行人次 通行类型
const getStatisticsAccessRecordData = (params) => {
  return http.post('/entrancecontrol/getStatisticsAccessRecordData', params)
}
// 门禁信息-新增门禁用户数据统计
const getStatisticsUserAuthData = (params) => {
  return http.post('/entrancecontrol/getStatisticsUserAuthData', params)
}
// 门禁信息-获取公司的门禁权限
const getEnterpriseEntranceAuth = (params) => {
  return http.post('/entrancecontrol/getEnterpriseEntranceAuth', params)
}
// 门禁信息-通行人次分页列表
const getAccessPageByEnterpriseId = (params) => {
  return http.post('/entrancecontrol/getAccessPageByEnterpriseId', params)
}
// 门禁信息-新增访客授权分页列表
const getAgentAuthPageByEnterpriseId = (params) => {
  return http.post('/entrancecontrol/getAgentAuthPageByEnterpriseId', params)
}
// 门禁信息-新增访客授权分页列表
const getUserAuthPageByEnterpriseId = (params) => {
  return http.post('/entrancecontrol/getUserAuthPageByEnterpriseId', params)
}
// 会议室预订-上传附件
const saveAttachent = (params) => {
  return http.post('/ipark-admin/processadmin/saveAttachent', params)
}
// 会议室预订-删除附件
const deleteAttachent = (params) => {
  return http.post('/ipark-admin/processadmin/deleteAttachent', params)
}

export default {
  selectMyTaskList,
  getTaskNodeList,
  importUserResult,
  selectAppovingDetailByPid,
  transfer,
  submit,
  addTaskComment,
  modifyRepairType,
  getRepairType,
  appMcardApply,
  mcardApplyCancel,
  enterpriseApplyList,
  serviceDataStatistics,
  enterpriseMcardStatistics,
  enterpriseMcardPageList,
  getStatisticsAgentAuthData,
  getStatisticsAccessRecordData,
  getStatisticsUserAuthData,
  getEnterpriseEntranceAuth,
  getAccessPageByEnterpriseId,
  getAgentAuthPageByEnterpriseId,
  getUserAuthPageByEnterpriseId,
  saveAttachent,
  deleteAttachent,
  getTaskNodeList1
}



// WEBPACK FOOTER //
// ./src/area-base/api/task.js